module.exports = __webpack_public_path__ + "img/explicacao2.13867404.png";